import CustomDraggable from 'Common/CustomDraggable/CustomDraggable'
import PopupFooter from 'Components/PopupFooter/PopupFooter'
import { LuShield, LuUser } from 'react-icons/lu'
import PopupHeader from 'Components/PopupHeader/PopupHeader'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import React, { useEffect, useState } from 'react'
import api from "../../http";
import MFA from './MFA'
import Profile from './Profile'
import FullPageLoader from 'Components/FullPageLoader/FullPageLoader'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import Validator, {
    ValidationTypes as V_Type,
  } from "react-form-supervalidator";
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import MaskPhoneNumber from 'Utils/MaskPhoneNumber'
import { RECORD_SAVED_SUCCESSFULLY } from 'Common/ToastConstants'

const UserProfilePopup = ({ onClose, disableDraggable }) => {
    const uniqueId = "UserProfilePopup"
    const { userinfo } = useSelector((state) => state.userAuth);
    const { firstName, lastName, phoneNumber } = userinfo;
    const [profileData , setProfileData] = useState({
        phoneNumber : "",
        firstName : "",
        lastName : "",
    })
    const [validationModel, setValidationModel] = useState({
        phoneError: null,
         
    });
    const [loading, setLoading] = useState(false);
    const setValidation = () => {
        let validation_Obj = {
          ...validationModel,
          phoneError: Validator(
            profileData.lastName,
            [V_Type.required],
            ["Phone Number is required"]
          ),
        };
        setValidationModel(validation_Obj);
        return Validator(validation_Obj, V_Type.NullCheck);
      };
    const handleSave = async () => {
        let my_validation = setValidation();
        if(!my_validation){
            try {
                setLoading(true);
              await api.post(
                `${process.env.REACT_APP_TC_AUTH}/api/TwoFactorAuthentication/UpdateUserContactInfo`,
                profileData
              );
                toast.success(RECORD_SAVED_SUCCESSFULLY);
           } catch (error) {
               ErrorHandlingMessage(error);
           } finally {
               setLoading(false);
           }
       }
    }

    const [selectedTab, setSelectedTab] = useState('profile');
    const tabs = [
        { key: 'profile', label: 'Profile', icon: LuUser },
        { key: 'mfa', label: 'MFA', icon: LuShield },
    ];

    const handleTab = (tab) => {
        setSelectedTab(tab);
    };
    const onHandleChange = (e) => {
        let { name, value } = e.target;
        value = name === "phoneNumber" ? MaskPhoneNumber(value, "removeMask") : value;
        setProfileData(prev => ({
            ...prev,
            [name]: value
        }));
    }
    useEffect(() => {
        setProfileData({firstName, lastName, phoneNumber})
    }, [firstName , lastName , phoneNumber])
    return (
        <ReactPortal wrapperId={uniqueId}>
            {loading && <FullPageLoader/>}
            <div data-te-modal-init className="fixed inset-0 z-10 flex items-center justify-center bg-gray-500 bg-opacity-75" id="exampleModalScrollable" tabIndex={-1} aria-labelledby="exampleModalScrollableLabel" aria-modal="true" data-te-open="true">
                <CustomDraggable disableDraggable={disableDraggable} handle={`#${uniqueId}`}>
                    <div data-te-modal-dialog-ref className="relative w-[900px]   min-[576px]:mx-auto min-[576px]:mt-2 min-[576px]:max-w-[500px] min-[992px]:max-w-[800px] min-[1200px]:max-w-[1140px] flex flex-col overflow-hidden rounded-md bg-white shadow-lg">
                        <div className='p-10 pt-0'>
                            <PopupHeader uniqueId={uniqueId} heading="User Profile" />

                            <div className="overflow-y-auto max-h-[70vh]">
                                <div className="flex mb-4">
                                    {tabs.map((tab) => {
                                        const Icon = tab.icon;
                                        return (
                                            <button
                                                key={tab.key}
                                                type="button"
                                                onClick={() => handleTab(tab.key)}
                                                className={`flex-1 px-2 py-4 text-sm font-medium transition-colors ${selectedTab === tab.key
                                                    ? 'text-primary2 border-b-2 border-primary2 bg-white'
                                                    : 'text-gray-500 border-b border-gray-200 hover:text-gray-700 hover:bg-gray-50'
                                                    }`}
                                            >
                                                <div className="flex items-center justify-center">
                                                    <Icon className="w-4 h-4 mr-2" />
                                                    {tab.label}
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                                {selectedTab === 'profile' && <Profile profileData={profileData} onHandleChange={onHandleChange} validationModel={validationModel}   />}
                                {selectedTab === 'mfa' && <MFA />}
                            </div>
                            <PopupFooter onClose={onClose} onConfirm={selectedTab === "profile" ? handleSave : undefined} />
                        </div>
                    </div>
                </CustomDraggable>
            </div>
        </ReactPortal>
    )
}

export default UserProfilePopup